import { ApiService } from "../..";

export const updateSampleLabel = (sampleId: string, data: {
  value: string
}) => {
  return ApiService.baseAction(
    `sample/update_sample_label/${sampleId}`,
    { data },
    "post"
  );
};
